import { Component, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'bs-digital-betbuilder-info-message',
    templateUrl: './betbuilder-info-message.component.html',
    styleUrls: ['./betbuilder-info-message.component.scss'],
    standalone: false,
})
export default class BetbuilderInfoMessageComponent {
    @Output() close = new EventEmitter<void>();

    constructor(
        public sitecore: Sitecore,
        private popupRef: ElementRef,
    ) {}

    @HostListener('document:click', ['$event'])
    closeInfoMessage(event: MouseEvent): void {
        if (this.popupRef && !this.popupRef.nativeElement.contains(event.target)) {
            this.close.emit();
        }
    }

    closeClick(event: Event): void {
        event.stopPropagation();
        this.close.emit();
    }
}
